import { IState } from "store/index";

export const insightsFiltersSelector = (state: IState) => state.app.insights;
